import(/* webpackMode: "eager" */ "/app/src/app/esm-2-to-1-stocks/page.tsx");
